export const getAgentName = (agentType: string) => {
    switch (agentType) {
        case "orderProcessing":
            return "Email Order Processing";
        case "marketingCampaign":
            return "Marketing Campaign";
        case "EDIAssistant":
            return "EDI Assistant";
        case "InventoryManagement":
            return "Inventory Management";
        default:
            return agentType;
    }
};

export const getTriggerName = (trigger: string) => {
    switch (trigger) {
        case "email":
            return "Email";
        case "auto_generate_email":
            return "Auto Generate Email";
        default:
            return trigger;
    }
};
